// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../../shared/services/fetch';
import { getBasePath } from '../../../../shared/services/get-base-path';
import { handleError } from '../../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getTransLogCriteria ( ) {

    const endPoint = `${basePath}/trans-logCriteria`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getTransLog ( payload ) {

    const endPoint = `${basePath}/trans-log`;
    const payLoad = {
        ...payload
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getRellocationLogCriteria ( ) {

    const endPoint = `${basePath}/reallocation-logCriteria`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getRellocationLog ( payLoad ) {

    const endPoint = `${basePath}/reallocation-log`;

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAtpTransLogCriteria ( ) {

    const endPoint = `${basePath}/atpdeere-searchvalues`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAtpTransDates ( ) {

    const endPoint = `${basePath}/atpdeere-transdates`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAtpBuildWeeks ( ) {

    const endPoint = `${basePath}/atpdeere-buildweeks`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAtpTransLog ( payload ) {

    const endPoint = `${basePath}/atpdeere-transactionlog`;
    const payLoad = {
        ...payload
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
